export const ABOUT_YOUNG_SPINE =
  "Young Spine is a specialized spine and musculoskeletal care clinic dedicated to helping people achieve a healthier, stronger, and pain-free spine. We provide personalized consultation and evidence-based care for common spine-related conditions, including back pain, neck pain, sciatica, and posture-related problems. Our approach focuses on accurate assessment, personalized treatment, rehabilitation, and preventive spine care.";

export const ABOUT_SIGNOFF = "Young Spine: Healthy Spine, Healthy Life.";

export const CLINIC_STORY =
  "Young Spine was started with the vision of providing specialized, accessible, and patient-focused care for people suffering from spine and musculoskeletal problems. The aim is to help patients understand the root causes of their pain rather than simply treating symptoms, while promoting proper posture, rehabilitation, and long-term spine health. Young Spine was created to bridge the gap between pain management and preventive care, helping people return to an active and healthy lifestyle.";

export const PHILOSOPHY =
  "Young Spine follows a patient-centered, holistic, and preventive approach to spine health and pain management. Our philosophy is to look beyond temporary pain relief and understand the underlying factors contributing to discomfort, including posture, lifestyle, movement patterns, and daily habits. We emphasize personalized care, patient education, rehabilitation, and prevention, helping individuals improve function and reduce the risk of recurring problems.";

export const DIAGNOSIS_INTRO =
  "A good diagnosis begins with understanding the person, not simply looking at an X-ray or scan. It includes:";

export const DIAGNOSIS_POINTS = [
  "A detailed medical history",
  "A clinical examination: posture, movement, muscle strength, tenderness and neurological function",
  "Identifying contributing factors such as work ergonomics, prolonged sitting, activity, sleep and weight",
  "Screening for warning signs that need urgent investigation or specialist referral",
  "Recommending investigations only when clinically indicated, rather than routinely for every patient",
];

export const PATHWAY = [
  { title: "Understand", text: "We listen to your symptoms, medical history, lifestyle, work, and daily activities." },
  { title: "Assess", text: "We perform a focused clinical examination and recommend investigations only when they are needed." },
  { title: "Identify", text: "We look for the likely cause of your pain and the factors that may be contributing to it, such as posture, inactivity, muscle weakness, or workplace strain." },
  { title: "Treat", text: "Your treatment may include appropriate medication, exercises, rehabilitation, posture and ergonomic correction, activity modification, and lifestyle changes." },
  { title: "Review and progress", text: "We monitor your recovery and adjust the plan as you improve." },
];

export const GOAL = ["Less pain.", "Better movement.", "Stronger function.", "Long-term spine health."];

export const FACTORS = {
  posture: "Poor posture and prolonged sitting, particularly desk and computer work",
  weakness: "Muscle weakness and physical inactivity",
  lifting: "Improper lifting, repetitive movements or workplace strain",
  ergonomics: "Poor ergonomics at work or at home",
  age: "Age-related changes in the spine and discs",
  weight: "Excess body weight",
  injury: "Previous injuries or recurrent strain",
  movement: "Inadequate movement patterns and lack of appropriate exercise",
  lifestyle: "Stress, poor sleep and lifestyle factors",
};

export const FACTORS_NOTE = "Back and spine problems usually have several contributing factors rather than a single cause.";

export const URGENT_SIGNS = [
  "Loss of bladder or bowel control",
  "Numbness around the groin or inner thighs",
  "New or worsening leg weakness",
  "Back pain after a serious fall or accident",
  "Back pain with fever or unexplained weight loss",
];

export const CARE_APPROACH =
  "Care at Young Spine is conservative and non-surgical only — no injections and no surgery. Investigations such as X-ray or CT scan are advised only when clinically needed.";

export const MEDICAL_DISCLAIMER =
  "The information on this website is for general education and is not a substitute for consultation with a qualified doctor.";

export const POLICY_LINKS = [
  { slug: "privacy-policy", label: "Privacy Policy" },
  { slug: "terms-and-conditions", label: "Terms & Conditions" },
  { slug: "shipping-policy", label: "Shipping Policy" },
  { slug: "refund-and-cancellation-policy", label: "Refund & Cancellation Policy" },
  { slug: "medical-disclaimer", label: "Medical Disclaimer" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Dr. Singh" },
  { to: "/conditions", label: "Conditions" },
  { to: "/services", label: "Services" },
  { to: "/shop", label: "Shop" },
  { to: "/contact", label: "Contact" },
];
